export default __webpack_public_path__ + "static/webRotator/svg/27117844ee8793bc3b7b5abdcd44ba4d.svg";